import styled from '@emotion/styled';
import { mediaQuery } from '@styles/index';
import { ArrowButton } from 'aquilla/core/molecules/Carousel';
import { useEffect, useRef, useState } from 'react';

const OuterContainer = styled.div`
  position: relative;
`;
const Container = styled.div`
  overflow: hidden;
  position: relative;

  ${mediaQuery.uptoTablet} {
    overflow: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;

const CarouselWrapper = styled.div`
  display: flex;
  gap: 16px;
  transition: transform linear 0.3s;
  transform: translateX(0px);
`;

const CarouselItem = styled.div`
  flex-shrink: 0;
`;

const RightBlur = styled.div`
  position: absolute;
  width: 17%;
  height: 100%;
  right: 0px;
  bottom: -0.2px;

  background: linear-gradient(
    270deg,
    #fcfcfc 0.39%,
    rgba(252, 252, 252, 0) 100%
  );

  z-index: 2;

  ${mediaQuery.uptoTablet} {
    display: none;
  }
`;
const StyledArrowButton = styled(ArrowButton)`
  z-index: 2;
  position: absolute;
  top: 50%;
  left: ${(props) => (props.type === 'prev' ? '0' : 'initial')};
  right: ${(props) => (props.type === 'next' ? '0' : 'initial')};
  border: 1px solid var(--color-i-divider);
  transform: ${(props) =>
    props.type === 'next' ? 'translate(50%, -50%)' : 'translate(-50%, -50%)'};
  ${mediaQuery.uptoTablet} {
    display: none;
  }
`;

const DemoClassesCarousel = ({ children }) => {
  const carouselRef = useRef(null);
  const carouselItemRef = useRef(null);
  const carouselItemWidth = useRef(0);
  const postRemainigCarouselLength = useRef(0);
  const preRemainigCarouselLength = useRef(0);
  const containerRef = useRef(null);
  const itemsOnScroll = useRef(2);
  const [isPrevDisable, setPrevDisable] = useState(true);
  const [isNextDisable, setNextDisable] = useState(false);

  const getTranslatedLength = (val) => {
    if (!val) return 0;
    return parseInt(val.match(/translateX\(-*\d+px\)/)[0].match(/-*\d+/), 10);
  };

  const handleButtonVisible = () => {
    setNextDisable(postRemainigCarouselLength.current === 0);
    setPrevDisable(preRemainigCarouselLength.current === 0);
  };

  const handleNext = () => {
    const translatedLength = getTranslatedLength(
      carouselRef.current.style.transform
    );
    if (postRemainigCarouselLength.current <= 0) return;
    if (
      postRemainigCarouselLength.current <
      itemsOnScroll.current * carouselItemWidth.current
    ) {
      carouselRef.current.style.transform = `translateX(${
        translatedLength -
        Math.ceil(
          postRemainigCarouselLength.current / carouselItemWidth.current
        ) *
          (carouselItemWidth.current + 16)
      }px)`;
      postRemainigCarouselLength.current = 0;
      setPrevDisable(true);
    } else {
      carouselRef.current.style.transform = `translateX(${
        translatedLength -
        itemsOnScroll.current * (carouselItemWidth.current + 16)
      }px)`;
      postRemainigCarouselLength.current -=
        itemsOnScroll.current * (carouselItemWidth.current + 16);
    }
    preRemainigCarouselLength.current = Math.abs(
      getTranslatedLength(carouselRef.current.style.transform)
    );
    handleButtonVisible();
  };

  const handlePrev = () => {
    const translatedLength = getTranslatedLength(
      carouselRef.current.style.transform
    );
    if (preRemainigCarouselLength.current <= 0) return;
    if (
      Math.abs(preRemainigCarouselLength.current) <
      itemsOnScroll.current * carouselItemWidth.current
    ) {
      carouselRef.current.style.transform = 'translateX(0px)';
      preRemainigCarouselLength.current = 0;
    } else {
      carouselRef.current.style.transform = `translateX(${
        translatedLength +
        itemsOnScroll.current * (carouselItemWidth.current + 16)
      }px)`;
      preRemainigCarouselLength.current -=
        itemsOnScroll.current * (carouselItemWidth.current + 16);
    }
    postRemainigCarouselLength.current =
      carouselRef.current.scrollWidth -
      containerRef.current.offsetWidth -
      preRemainigCarouselLength.current;
    handleButtonVisible();
  };

  useEffect(() => {
    carouselItemWidth.current = carouselItemRef.current.firstChild.offsetWidth;
    postRemainigCarouselLength.current =
      carouselRef.current.scrollWidth - containerRef.current.offsetWidth;
    itemsOnScroll.current = Math.floor(
      containerRef.current.offsetWidth / carouselItemWidth.current
    );
    if (postRemainigCarouselLength.current !== 0 && isNextDisable)
      setNextDisable(false);
    handleButtonVisible();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <OuterContainer>
      <Container ref={containerRef}>
        <CarouselWrapper ref={carouselRef}>
          {children.map((child, index) => (
            <CarouselItem
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              ref={index === 0 ? carouselItemRef : null}
            >
              {child}
            </CarouselItem>
          ))}
        </CarouselWrapper>
        <RightBlur />
      </Container>
      {!isPrevDisable && (
        <StyledArrowButton
          type="prev"
          disabled={isPrevDisable}
          onClick={handlePrev}
        />
      )}
      {!isNextDisable && (
        <StyledArrowButton
          type="next"
          disabled={isNextDisable}
          onClick={handleNext}
        />
      )}
    </OuterContainer>
  );
};

export default DemoClassesCarousel;
